import { Data } from '../../../service/interfaces/Data';

export class Calculo{
    Matricula: number;
    Tipo:  number = 0;
    DataInicial: Data = new Data() ;
    DataFinal: Data= new Data();
    Sequencial: string = ""
}
